import { EXTRA_EN, EXTRA_FR } from "./i18nExtra";
// Homepage UI string translations. Admin-provided content (hero text, category
// overrides) is handled separately; this covers the fixed homepage chrome.
export const TRANSLATIONS = {
  en: {
    search_placeholder: "What are you looking for?",
    search_button: "Search",
    categories_heading: "Browse by category",
    fresh_listings: "Fresh listings",
    fresh_sub: "Newly posted across Canada",
    fresh_load_more: "Load more listings",
    view_all: "View all",
    trust1_t: "Verified sellers",
    home_verify_badge: "Sellers & businesses",
    home_verify_title: "Get verified and stand out",
    home_verify_title_b: "Turn browsers into buyers — get verified",
    home_verify_sub: "Earn a trust badge and unlock a premium mini-webpage profile — cover banner, photo gallery, reviews, a shareable card and a branded QR code. Apply in under a minute.",
    home_verify_cta: "Get verified",
    trust1_d: "Look for the green badge — verified breeders, shelters and businesses with real reviews.",
    trust2_t: "AI-assisted posting",
    trust2_d: "Write a great listing in seconds with our built-in AI description generator.",
    trust3_t: "Safe messaging",
    trust3_d: "Chat in-app and get email alerts. Keep your phone & email private until you choose to share.",
    nav_post_ad: "Post Ad",
    nav_sign_in: "Sign in",
    nav_contact: "Contact Us",
    nav_get_verified: "Get Verified",
    nav_browse: "Browse",
    nav_dashboard: "Dashboard",
    nav_messages: "Messages",
    nav_advertise: "Advertise",
    nav_favorites: "Favorites",
    nav_profile: "My public profile",
    nav_logout: "Log out",
    footer_browse: "Browse",
    footer_company: "Company",
    footer_tagline: "Canada's friendly marketplace for pets, adoptions, supplies and services. Post free, connect local.",
    footer_safety_h: "Safety First",
    footer_safety_d: "Always meet in person, verify health records, and never send payment before meeting a pet. Adopt responsibly. 🐾",
    footer_made: "Made in Canada.",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    footer_cookies: "Cookie preferences",
    footer_about: "About us",
    footer_how: "How it works",
    footer_trust: "Trust & safety",
    footer_get_verified: "Get verified",
    footer_contact: "Contact",
    footer_advertise: "Advertise",
    footer_where_ads: "Where ads appear",
    br_filters: "Filters",
    br_clear: "Clear",
    br_keyword: "Keyword",
    br_province: "Province",
    br_city: "City",
    br_price_range: "Price range",
    br_min: "Min",
    br_max: "Max",
    br_apply: "Apply filters",
    br_results: "results",
    br_in: "in",
    br_newest: "Newest first",
    br_best_match: "Best match",
    br_including: "Including results for",
    br_oldest: "Oldest first",
    br_price_low: "Price: low to high",
    br_price_high: "Price: high to low",
    br_none: "No listings match your filters.",
    br_clear_filters: "Clear filters",
    ld_message_seller: "Message seller",
    ld_contact_seller: "Contact seller",
    ld_send: "Send message",
    ld_placeholder: "Hi! I'm interested in your listing…",
    ld_safety: "Meet in person & never send money before meeting.",
    ld_show_email: "Show email",
    ld_show_phone: "Show phone number",
    ld_report: "Report listing",
    ld_description: "Description",
    ld_details: "Details",
    ld_share: "Share",
    ld_free: "Free",
    ld_contact_price: "Contact for price",
    ld_back: "Back",
    ld_views: "views",
    ld_expired: "Expired",
    ld_expires_in: "Expires in",
    ld_day: "day",
    ld_days: "days",
    ld_species: "Species",
    ld_breed: "Breed",
    ld_age: "Age",
    ld_no_photo: "No photo",
    ld_no_description: "No description provided.",
    ld_view_profile: "View profile",
    ld_reachable: "Usually replies within minutes",
    ld_active_now: "Active now",
    ld_verified: "Verified",
    ld_pending_title: "Pending review.",
    ld_pending_body: "This ad is awaiting approval by our team and isn't visible to the public yet.",
    ld_staff_edit: "Edit ad",
    post_staff_editing: "You're editing this ad as staff. Changes apply right away and the approval status stays the same.",
    post_save_approve: "Save & approve",
    post_save_changes: "Save changes",
    post_saved_approved: "Saved & approved — the ad is now live",
    ld_rejected_title: "Not approved.",
    ld_rejected_reason: "Reason:",
    ld_rejected_body: "This ad did not meet our guidelines.",
    ld_renew_30: "Renew for 30 days",
    ld_manage_dash: "Manage in dashboard",
    ld_your_listing: "This is your listing",
    ld_expired_owner: "This ad has expired. Renew it to make it visible again for another 30 days.",
    ld_expired_public: "This listing has expired and is no longer available.",
    ld_tpl_available: "Is this still available?",
    ld_tpl_visit: "Can I arrange a visit?",
    ld_tpl_health: "Are health records available?",
    // Listing card
    lc_featured: "Featured",
    lf_lost: "LOST", lf_found: "FOUND", lf_all: "All reports", lf_tab_lost: "Lost pets", lf_tab_found: "Found pets",
    lf_title: "Lost or found a pet?", lf_sub: "Every minute counts. Post a report, share it with neighbours and help bring them home.",
    lf_report_lost: "Report a lost pet", lf_report_found: "Report a found pet", lf_type_label: "Report type", lf_need_type: "Choose whether this pet is Lost or Found",
    lfd_section: "Pet details", lfd_date_missing: "Date missing", lfd_date_found: "Date found", lfd_last_seen: "Last seen", lfd_where_found: "Where found",
    lfd_last_seen_ph: "e.g. Near High Park, Bloor St W & Keele", lfd_gender: "Gender", lfd_select: "Select…",
    lfd_g_male: "Male", lfd_g_female: "Female", lfd_g_neutered_male: "Neutered male", lfd_g_spayed_female: "Spayed female", lfd_g_unknown: "Unknown",
    lfd_microchip: "Microchipped", lfd_c_yes: "Yes", lfd_c_no: "No", lfd_c_unknown: "Unknown",
    lfd_collar: "Collar / tag info", lfd_collar_ph: "e.g. Red leather collar, bone-shaped tag reading \"Max\"",
    lfd_markings: "Distinctive markings", lfd_markings_ph: "e.g. White patch on chest, notch in left ear",
    lfd_need: "Please add the date and where the pet was last seen",
    lfm_today: "today", lfm_day: "day", lfm_days: "days", lfm_weeks: "weeks", lfm_month: "month", lfm_months: "months",
    lfm_missing: "Missing", lfm_found: "Found", lfm_ago: "ago", lfm_missing_today: "Missing today", lfm_found_today: "Found today",
    lfm_tip_title: "Free microchip scan",
    sa_title: "Sighting emails", sa_desc: "Get an email the moment someone pins a sighting of your lost pet. Several sightings within 15 minutes are grouped into one email. You'll always get an in-site message.", sa_on: "Sighting emails on", sa_off: "Sighting emails off — you'll still get in-site messages",
    lfm_tip_body: "Any vet clinic, animal shelter or animal services office can scan for a microchip for free — it only takes a minute.",
    lf_flyer_title: "Help spread the word", lf_flyer_sub: "Print a flyer for your neighbourhood or share it online.", lf_flyer_pdf: "Download PDF flyer", lf_flyer_png: "Download image", lf_flyer_thumb: "Flyer", sad_title: "Share this ad", fp_title: "Thanks for posting!", fp_follow: "Follow CritterPosts for pet tips, success stories and new features.", fp_share_only: "Share your ad to reach more pet lovers.", fp_share_now: "Share your ad to reach more buyers", fp_pending: "Your ad is being reviewed. We'll let you know once it's live — then share it with friends!", fp_close: "Got it", fp_never: "Don't show again", fsh_title: "Share flyer", fsh_native: "Share", fsh_sms: "Text", fsh_copy: "Copy link", fsh_copied: "Link copied — paste it anywhere", fsh_failed: "Couldn't share — try another option",
    fsh_lost: "LOST: {title}, last seen {spot}. Please share!", fsh_found: "FOUND: {title}, found near {spot}. Is this your pet? Please share!",
    lff_label: "Phone number for printed flyer", lff_hint: "Only appears on the downloaded flyer — never shown on your ad online.", lff_save: "Save", lff_saved: "Phone added to your flyer", lff_removed: "Phone removed from your flyer",
    lfa_title: "Lost & Found alerts near me", lfa_desc: "Get an email as soon as a lost or found pet is reported near you.", lfa_city: "City", lfa_province: "Province", lfa_radius: "Alert radius", lfa_save: "Save alert area", lfa_saved: "Alert settings saved", lfa_approx: "We don't know the exact location of this city yet, so distance is measured from the centre of your province.",
    lf_featured: "Urgent & featured reports",
    nav_more: "More", ce_title: "Email address", ce_current: "Current:", ce_google: "You sign in with Google, so your email is managed by your Google account.", ce_pending: "Waiting for you to confirm", ce_pending2: "Check that inbox (link valid 1 hour).", ce_new: "New email", ce_pw: "Current password", ce_send: "Send confirmation link", ce_hint: "Your email only changes after you click the link sent to the new address.", ce_sent: "Confirmation link sent to", ce_cancelled: "Email change cancelled", ce_ok_title: "Email updated", ce_ok_body: "Your account now uses", ce_ok_body2: "Use it the next time you log in.", ce_err_title: "Couldn't confirm", ce_profile: "Go to my profile", ce_missing: "This confirmation link is missing its token.", se_title: "Seasonal news & holiday tips", se_signup: "Send me seasonal news & holiday pet tips from CritterPosts. Unsubscribe any time.", se_desc: "Occasional holiday emails with pet safety tips, adoption drives and seasonal deals.", se_on: "Seasonal news on", se_off: "Seasonal news off", pv_title: "Profile views · last 7 days", pv_new: "New this week", pv_none: "No views yet", pv_vs: "vs prev. 7 days", pv_all: "all-time", pv_today: "Today", lfr_back_home: "Back home", rh_kicker: "Happy endings", rh_title: "Happy reunions", rh_sub: "Real pets back home thanks to the CritterPosts community.", rh_all: "See all reunions", rsh_title: "Share the good news", rsh_sub: "Thank your neighbours online with this reunion card.", rsh_text: "Reunited! Thank you to everyone who helped:", rsh_copy: "Copy link", rsh_copied: "Link copied", rsh_download: "Download image", rs_title: "Add your reunion story", rs_edit_title: "Your reunion story", rs_sub: "Share a happy photo and a thank-you note for everyone who helped. It shows on the Happy reunions tab.", rs_photo: "Happy photo", rs_note: "Thank-you note", rs_note_ph: "Thank you so much to everyone who shared and searched!", rs_save: "Save story", rs_saved: "Reunion story saved", rs_remove: "Remove story", rs_removed: "Story removed", rs_need: "Add a photo or a thank-you note", lf_reunited: "REUNITED", lf_tab_reunited: "Happy reunions",
    lfr_banner_title: "Reunited! This pet is back home", lfr_banner_sub: "Thank you to everyone who shared, searched and kept an eye out.",
    lfr_mark: "Mark as reunited", lfr_unmark: "Undo reunited", lfr_done: "Wonderful news! Marked as reunited", lfr_confirm: "Mark this pet as reunited? Members who got an alert will receive the good news.",
    sg_title: "Sightings", sg_sub: "Seen this pet? Tap the map where you saw it.", sg_report: "I saw this pet", sg_cancel: "Cancel", sg_pick: "Click the map to drop a pin where you saw the pet.", sg_when: "When did you see it?", sg_note: "Note (optional)", sg_note_ph: "e.g. heading north on Bloor St, looked scared", sg_photo: "Add photo (optional)", sg_submit: "Submit sighting", sg_sent: "Thank you! The owner has been notified.", sg_none: "No sightings reported yet.", sg_need_pin: "Drop a pin on the map first", sg_latest: "Latest", sg_remove: "Remove", sg_by: "by",
    lc_pinned: "Pinned",
    lc_verified: "Verified",
    lc_verified_seller: "Verified Seller",
    lc_verified_breeder: "Verified Breeder", lc_verified_business: "Verified Business",
    br_verified: "Verification",
    br_verified_all: "All sellers",
    lc_active_now: "Active now",
    lc_no_photo: "No photo",
    cat_all: "All Listings",
    // Dashboard
    d_title: "My Dashboard",
    d_post_ad: "Post Ad",
    d_tab_listings: "My Listings",
    d_tab_messages: "Messages",
    d_tab_favorites: "Favorites",
    d_tab_profile: "Profile",
    d_loading: "Loading",
    d_no_listings: "You haven't posted any ads yet.",
    d_post_first: "Post your first ad",
    d_views: "views",
    d_pending: "Pending review",
    d_not_approved: "Not approved",
    d_expired: "Expired",
    d_days_left: "d left",
    d_edit_pending: "Edit pending review",
    d_renew: "Renew",
    d_renewed: "Renewed for 30 days",
    d_listing_removed: "Listing removed",
    d_delete_listing_q: "Delete this listing?",
    d_delete_listing_desc: "This will remove this listing permanently.",
    d_cancel: "Cancel",
    d_delete: "Delete",
    d_no_favorites: "No saved listings yet. Tap the heart on any listing to save it.",
    d_edit_profile: "Edit your profile",
    d_tap_camera: "Tap the camera to upload a profile photo",
    d_badge_shown: "badge — shown across CritterPosts",
    d_full_name: "Full name",
    d_public_username: "Public username",
    d_username_help: "This is the name shown publicly on your ads. 3-20 characters: letters, numbers, underscores. Leave blank to show your full name.",
    d_phone_label: "Phone (only shown on ads if you enable it)",
    d_bio: "Bio",
    d_bio_ph: "Tell buyers a bit about yourself…",
    d_save_changes: "Save changes",
    d_profile_updated: "Profile updated!",
    d_photo_updated: "Photo updated!",
    d_2fa_title: "Two-factor login",
    d_2fa_desc: "When on, we'll email a 6-digit code you enter at sign-in — extra protection if your password is ever leaked.",
    d_secq_title: "Security question",
    d_secq_set: "Set — you can reset your password with this if you lose email access.",
    d_secq_unset: "Set one so you can recover your account without email.",
    d_secq_choose: "Choose a question",
    d_secq_update: "Update",
    d_secq_save: "Save",
    d_blocked_title: "Blocked users",
    d_blocked_some: "These people can't message you.",
    d_blocked_none: "You haven't blocked anyone. Block someone from a chat to stop their messages.",
    d_weekly_title: "Weekly recap email",
    d_weekly_desc: "Get a Monday summary of your listing views and new messages from the past week.",
    d_verify_title: "Seller verification",
    d_verify_verified: "You're a verified seller — the badge shows on your profile & listings.",
    d_verify_pending: "Your request is under review. We'll message you once it's decided.",
    d_verify_rejected: "Your last request wasn't approved.",
    d_verify_reason: "Reason:",
    d_verify_cta_intro: "Earn a verified badge that builds buyer trust. Submit a quick document for review.",
    d_verify_new_request: "Submit a new request",
    d_verify_request: "Request verification",
    d_no_messages: "No messages yet. Inquiries you send and receive will appear here.",
    d_select_conv: "Select a conversation",
    d_type_message: "Type a message…",
    d_unblock_to_send: "Unblock to send messages",
    d_seen: "Seen",
    d_mute: "Mute",
    d_unmute: "Unmute",
    d_block: "Block",
    d_unblock: "Unblock",
    d_report: "Report",
    d_announcement: "Announcement",
    d_direct_message: "Direct message",
    d_with: "with",
    d_message_deleted: "This message was deleted",
    d_edited: "(edited)",
    d_blocked_banner: "You've blocked this user. Unblock to exchange messages.",
    d_verify_dlg_title: "Request verification",
    d_verify_dlg_desc_biz: "Verify your business or operation to earn a trust badge.",
    d_verify_dlg_desc_ind: "Verify your identity to earn a trust badge.",
    d_verify_biz_name: "Business / operation name",
    d_verify_website: "Website (optional)",
    d_verify_full_name_label: "Full legal name",
    d_verify_full_name_ph: "As it appears on your ID",
    d_verify_verified_cat: "You're a {badge} — the badge shows on your profile & listings.", d_verify_dlg_desc_breeder: "Show you're a responsible breeder to earn the purple Verified Breeder badge.", d_verify_doc_breeder: "Club / kennel registration or vet reference",
    d_verify_doc_biz: "Business license / registration",
    d_verify_doc_id: "Government-issued ID",
    d_verify_upload: "Upload image or PDF",
    d_verify_doc_uploaded: "Document uploaded",
    d_verify_doc_note: "Your document is only used for review and is never shown publicly.",
    d_verify_submit: "Submit for review",
    d_rm_title: "Report message",
    d_rm_desc: "This message and your reason are sent to our moderators to review.",
    d_rm_note_ph: "Add any details (optional)…",
    d_rm_send: "Send report",
    d_dm_title: "Delete this message?",
    d_dm_desc: "The message will be replaced with \"This message was deleted\" for everyone in the chat. This can't be undone.",
    d_cc_title: "Delete this conversation?",
    d_cc_desc: "It will be removed from your list. The other person keeps their copy, and it can reappear if either of you sends a new message.",
    // Post ad / Create listing
    post_edit_title: "Edit ad",
    post_title: "Post an ad",
    post_sub: "Reach thousands of pet lovers across Canada — it's free.",
    post_canada: "All posts must be within Canada 🇨🇦",
    post_photos: "Photos",
    post_add_photos: "Add photos",
    post_max_photos: "Maximum photos reached. Remove one to add another.",
    post_details: "Details",
    post_category: "Category",
    post_title_label: "Title",
    post_title_ph: "e.g. Adorable Golden Retriever Puppies",
    post_species: "Species",
    post_breed: "Breed",
    post_age: "Age",
    post_description: "Description",
    post_generate_ai: "Generate with AI",
    post_desc_ph: "Describe the pet, item or service…",
    post_price_location: "Price & Location",
    post_price_type: "Price type",
    post_price_cad: "Price (CAD)",
    post_province: "Province",
    post_city: "City",
    post_contact_prefs: "Contact preferences",
    post_contact_sub: "Buyers can always message you in-app. Choose what else to show publicly.",
    post_show_email: "Show my email",
    post_show_phone: "Show my phone",
    post_submit: "Post my ad",
    post_fixed: "Fixed price",
    post_free: "Free / adoption",
    post_contact: "Contact for price",
    post_submitted: "Submitted! Your ad will go live once approved by our team.",
    post_updated: "Listing updated!",
    post_need_title_city: "Please add a title and city",
  },
  fr: {
    search_placeholder: "Que recherchez-vous ?",
    search_button: "Rechercher",
    categories_heading: "Parcourir par catégorie",
    fresh_listings: "Nouvelles annonces",
    fresh_sub: "Publiées récemment partout au Canada",
    fresh_load_more: "Voir plus d'annonces",
    view_all: "Voir tout",
    trust1_t: "Vendeurs vérifiés",
    home_verify_badge: "Vendeurs et entreprises",
    home_verify_title: "Faites-vous vérifier et démarquez-vous",
    home_verify_title_b: "Transformez les curieux en acheteurs — vérifiez-vous",
    home_verify_sub: "Obtenez un badge de confiance et débloquez un profil mini-page web premium — bannière, galerie photo, avis, carte de partage et code QR à votre marque. Postulez en moins d'une minute.",
    home_verify_cta: "Se faire vérifier",
    trust1_d: "Repérez le badge vert — éleveurs, refuges et entreprises vérifiés avec de vrais avis.",
    trust2_t: "Publication assistée par IA",
    trust2_d: "Rédigez une belle annonce en quelques secondes grâce à notre générateur de description IA.",
    trust3_t: "Messagerie sécurisée",
    trust3_d: "Discutez dans l'application et recevez des alertes par courriel. Gardez votre téléphone et courriel privés jusqu'à ce que vous décidiez de les partager.",
    nav_post_ad: "Publier",
    nav_sign_in: "Se connecter",
    nav_contact: "Nous joindre",
    nav_get_verified: "Se faire vérifier",
    nav_browse: "Parcourir",
    nav_dashboard: "Tableau de bord",
    nav_messages: "Messages",
    nav_advertise: "Annoncer",
    nav_favorites: "Favoris",
    nav_profile: "Mon profil public",
    nav_logout: "Se déconnecter",
    footer_browse: "Parcourir",
    footer_company: "Entreprise",
    footer_tagline: "Le marché convivial du Canada pour les animaux, les adoptions, les fournitures et les services. Publiez gratuitement, connectez-vous localement.",
    footer_safety_h: "La sécurité avant tout",
    footer_safety_d: "Rencontrez toujours la personne en personne, vérifiez les dossiers de santé et n'envoyez jamais de paiement avant d'avoir vu l'animal. Adoptez de façon responsable. 🐾",
    footer_made: "Fait au Canada.",
    footer_privacy: "Confidentialité",
    footer_terms: "Conditions",
    footer_cookies: "Préférences de témoins",
    footer_about: "À propos",
    footer_how: "Comment ça marche",
    footer_trust: "Confiance et sécurité",
    footer_get_verified: "Faites-vous vérifier",
    footer_contact: "Contact",
    footer_advertise: "Annoncer",
    footer_where_ads: "Où vos annonces apparaissent",
    br_filters: "Filtres",
    br_clear: "Effacer",
    br_keyword: "Mot-clé",
    br_province: "Province",
    br_city: "Ville",
    br_price_range: "Fourchette de prix",
    br_min: "Min",
    br_max: "Max",
    br_apply: "Appliquer les filtres",
    br_results: "résultats",
    br_in: "à",
    br_newest: "Plus récentes",
    br_best_match: "Meilleure correspondance",
    br_including: "Résultats incluant",
    br_oldest: "Plus anciennes",
    br_price_low: "Prix : croissant",
    br_price_high: "Prix : décroissant",
    br_none: "Aucune annonce ne correspond à vos filtres.",
    br_clear_filters: "Effacer les filtres",
    ld_message_seller: "Contacter le vendeur",
    ld_contact_seller: "Contacter le vendeur",
    ld_send: "Envoyer le message",
    ld_placeholder: "Bonjour ! Je suis intéressé(e) par votre annonce…",
    ld_safety: "Rencontrez la personne en personne et n'envoyez jamais d'argent avant la rencontre.",
    ld_show_email: "Afficher le courriel",
    ld_show_phone: "Afficher le numéro de téléphone",
    ld_report: "Signaler l'annonce",
    ld_description: "Description",
    ld_details: "Détails",
    ld_share: "Partager",
    ld_free: "Gratuit",
    ld_contact_price: "Prix sur demande",
    ld_back: "Retour",
    ld_views: "vues",
    ld_expired: "Expirée",
    ld_expires_in: "Expire dans",
    ld_day: "jour",
    ld_days: "jours",
    ld_species: "Espèce",
    ld_breed: "Race",
    ld_age: "Âge",
    ld_no_photo: "Aucune photo",
    ld_no_description: "Aucune description fournie.",
    ld_view_profile: "Voir le profil",
    ld_reachable: "Répond généralement en quelques minutes",
    ld_active_now: "En ligne",
    ld_verified: "Vérifié",
    ld_pending_title: "En attente de révision.",
    ld_pending_body: "Cette annonce attend l'approbation de notre équipe et n'est pas encore visible du public.",
    ld_staff_edit: "Modifier l'annonce",
    post_staff_editing: "Vous modifiez cette annonce en tant que membre du personnel. Les changements s'appliquent tout de suite et le statut d'approbation ne change pas.",
    post_save_approve: "Enregistrer et approuver",
    post_save_changes: "Enregistrer les modifications",
    post_saved_approved: "Enregistrée et approuvée — l'annonce est en ligne",
    ld_rejected_title: "Non approuvée.",
    ld_rejected_reason: "Raison :",
    ld_rejected_body: "Cette annonce ne respectait pas nos règles.",
    ld_renew_30: "Renouveler pour 30 jours",
    ld_manage_dash: "Gérer dans le tableau de bord",
    ld_your_listing: "Ceci est votre annonce",
    ld_expired_owner: "Cette annonce a expiré. Renouvelez-la pour la rendre à nouveau visible pendant 30 jours.",
    ld_expired_public: "Cette annonce a expiré et n'est plus disponible.",
    ld_tpl_available: "Est-ce toujours disponible ?",
    ld_tpl_visit: "Puis-je organiser une visite ?",
    ld_tpl_health: "Les dossiers de santé sont-ils disponibles ?",
    // Listing card
    lc_featured: "En vedette",
    lf_lost: "PERDU", lf_found: "TROUVÉ", lf_all: "Tous les signalements", lf_tab_lost: "Animaux perdus", lf_tab_found: "Animaux trouvés",
    lf_title: "Vous avez perdu ou trouvé un animal?", lf_sub: "Chaque minute compte. Publiez un signalement, partagez-le avec vos voisins et aidez-les à rentrer à la maison.",
    lf_report_lost: "Signaler un animal perdu", lf_report_found: "Signaler un animal trouvé", lf_type_label: "Type de signalement", lf_need_type: "Indiquez si l'animal est perdu ou trouvé",
    lfd_section: "Détails de l'animal", lfd_date_missing: "Date de disparition", lfd_date_found: "Date où il a été trouvé", lfd_last_seen: "Vu pour la dernière fois", lfd_where_found: "Lieu où il a été trouvé",
    lfd_last_seen_ph: "ex. Près du parc La Fontaine, rue Rachel", lfd_gender: "Sexe", lfd_select: "Choisir…",
    lfd_g_male: "Mâle", lfd_g_female: "Femelle", lfd_g_neutered_male: "Mâle castré", lfd_g_spayed_female: "Femelle stérilisée", lfd_g_unknown: "Inconnu",
    lfd_microchip: "Micropuce", lfd_c_yes: "Oui", lfd_c_no: "Non", lfd_c_unknown: "Inconnu",
    lfd_collar: "Collier / médaille", lfd_collar_ph: "ex. Collier rouge en cuir, médaille en os « Max »",
    lfd_markings: "Signes distinctifs", lfd_markings_ph: "ex. Tache blanche sur la poitrine, encoche à l'oreille gauche",
    lfd_need: "Veuillez indiquer la date et l'endroit où l'animal a été vu pour la dernière fois",
    lfm_today: "aujourd'hui", lfm_day: "jour", lfm_days: "jours", lfm_weeks: "semaines", lfm_month: "mois", lfm_months: "mois",
    lfm_missing: "Disparu depuis", lfm_found: "Trouvé il y a", lfm_ago: "", lfm_missing_today: "Disparu aujourd'hui", lfm_found_today: "Trouvé aujourd'hui",
    lfm_tip_title: "Lecture de micropuce gratuite",
    sa_title: "Courriels d'observation", sa_desc: "Recevez un courriel dès qu'une personne signale avoir vu votre animal perdu. Plusieurs observations en 15 minutes sont regroupées. Vous recevrez toujours un message sur le site.", sa_on: "Courriels d'observation activés", sa_off: "Courriels d'observation désactivés — vous recevrez encore les messages sur le site",
    lfm_tip_body: "N'importe quelle clinique vétérinaire, refuge ou service animalier peut lire une micropuce gratuitement — ça ne prend qu'une minute.",
    lf_flyer_title: "Aidez à passer le mot", lf_flyer_sub: "Imprimez une affiche pour votre quartier ou partagez-la en ligne.", lf_flyer_pdf: "Télécharger l'affiche PDF", lf_flyer_png: "Télécharger l'image", lf_flyer_thumb: "Affiche", sad_title: "Partager cette annonce", fp_title: "Merci d'avoir publié!", fp_follow: "Suivez CritterPosts pour des conseils, des histoires heureuses et les nouveautés.", fp_share_only: "Partagez votre annonce pour joindre plus d'amoureux des animaux.", fp_share_now: "Partagez votre annonce pour joindre plus d'acheteurs", fp_pending: "Votre annonce est en révision. Nous vous avertirons quand elle sera en ligne — partagez-la ensuite!", fp_close: "Compris", fp_never: "Ne plus afficher", fsh_title: "Partager l'affiche", fsh_native: "Partager", fsh_sms: "Texto", fsh_copy: "Copier le lien", fsh_copied: "Lien copié — collez-le n'importe où", fsh_failed: "Partage impossible — essayez une autre option",
    fsh_lost: "PERDU : {title}, vu pour la dernière fois {spot}. Partagez SVP!", fsh_found: "TROUVÉ : {title}, trouvé près de {spot}. Est-ce votre animal? Partagez SVP!",
    lff_label: "Numéro de téléphone pour l'affiche", lff_hint: "Apparaît seulement sur l'affiche téléchargée — jamais sur votre annonce en ligne.", lff_save: "Enregistrer", lff_saved: "Numéro ajouté à votre affiche", lff_removed: "Numéro retiré de votre affiche",
    lfa_title: "Alertes Perdus et trouvés près de chez moi", lfa_desc: "Recevez un courriel dès qu'un animal perdu ou trouvé est signalé près de chez vous.", lfa_city: "Ville", lfa_province: "Province", lfa_radius: "Rayon d'alerte", lfa_save: "Enregistrer la zone", lfa_saved: "Alertes enregistrées", lfa_approx: "Nous ne connaissons pas encore la position exacte de cette ville; la distance est mesurée depuis le centre de votre province.",
    lf_featured: "Signalements urgents et en vedette",
    nav_more: "Plus", ce_title: "Adresse courriel", ce_current: "Actuelle :", ce_google: "Vous vous connectez avec Google : votre adresse est gérée par votre compte Google.", ce_pending: "En attente de confirmation de", ce_pending2: "Vérifiez cette boîte de réception (lien valide 1 heure).", ce_new: "Nouvelle adresse", ce_pw: "Mot de passe actuel", ce_send: "Envoyer le lien de confirmation", ce_hint: "Votre adresse ne change qu'après avoir cliqué sur le lien envoyé à la nouvelle adresse.", ce_sent: "Lien de confirmation envoyé à", ce_cancelled: "Changement d'adresse annulé", ce_ok_title: "Adresse mise à jour", ce_ok_body: "Votre compte utilise maintenant", ce_ok_body2: "Utilisez-la lors de votre prochaine connexion.", ce_err_title: "Confirmation impossible", ce_profile: "Aller à mon profil", ce_missing: "Ce lien de confirmation ne contient pas de jeton.", se_title: "Nouvelles saisonnières et conseils des fêtes", se_signup: "Envoyez-moi les nouvelles saisonnières et conseils des fêtes de CritterPosts. Désabonnement en tout temps.", se_desc: "Des courriels occasionnels avec des conseils de sécurité, des campagnes d'adoption et des offres saisonnières.", se_on: "Nouvelles saisonnières activées", se_off: "Nouvelles saisonnières désactivées", pv_title: "Vues du profil · 7 derniers jours", pv_new: "Nouveau cette semaine", pv_none: "Aucune vue pour l'instant", pv_vs: "vs 7 jours précédents", pv_all: "au total", pv_today: "Auj.", lfr_back_home: "De retour à la maison", rh_kicker: "Fins heureuses", rh_title: "Retrouvailles", rh_sub: "De vrais animaux rentrés à la maison grâce à la communauté CritterPosts.", rh_all: "Voir toutes les retrouvailles", rsh_title: "Partagez la bonne nouvelle", rsh_sub: "Remerciez vos voisins en ligne avec cette carte de retrouvailles.", rsh_text: "Réunis! Merci à tous ceux qui ont aidé :", rsh_copy: "Copier le lien", rsh_copied: "Lien copié", rsh_download: "Télécharger l'image", rs_title: "Ajoutez votre histoire de retrouvailles", rs_edit_title: "Votre histoire de retrouvailles", rs_sub: "Partagez une photo joyeuse et un mot de remerciement pour tous ceux qui ont aidé. Elle s'affiche dans l'onglet Retrouvailles.", rs_photo: "Photo joyeuse", rs_note: "Mot de remerciement", rs_note_ph: "Merci infiniment à tous ceux qui ont partagé et cherché!", rs_save: "Enregistrer l'histoire", rs_saved: "Histoire enregistrée", rs_remove: "Retirer l'histoire", rs_removed: "Histoire retirée", rs_need: "Ajoutez une photo ou un mot de remerciement", lf_reunited: "RÉUNI", lf_tab_reunited: "Retrouvailles",
    lfr_banner_title: "Réuni! Cet animal est de retour à la maison", lfr_banner_sub: "Merci à tous ceux qui ont partagé, cherché et gardé l'œil ouvert.",
    lfr_mark: "Marquer comme réuni", lfr_unmark: "Annuler « réuni »", lfr_done: "Excellente nouvelle! Marqué comme réuni", lfr_confirm: "Marquer cet animal comme réuni? Les membres alertés recevront la bonne nouvelle.",
    sg_title: "Observations", sg_sub: "Vous avez vu cet animal? Touchez la carte à l'endroit où vous l'avez vu.", sg_report: "J'ai vu cet animal", sg_cancel: "Annuler", sg_pick: "Cliquez sur la carte pour placer une épingle à l'endroit où vous l'avez vu.", sg_when: "Quand l'avez-vous vu?", sg_note: "Note (facultatif)", sg_note_ph: "ex. se dirigeait vers le nord sur la rue Bloor, semblait effrayé", sg_photo: "Ajouter une photo (facultatif)", sg_submit: "Envoyer l'observation", sg_sent: "Merci! Le propriétaire a été avisé.", sg_none: "Aucune observation signalée pour l'instant.", sg_need_pin: "Placez d'abord une épingle sur la carte", sg_latest: "Plus récente", sg_remove: "Retirer", sg_by: "par",
    lc_pinned: "Épinglé",
    lc_verified: "Vérifié",
    lc_verified_seller: "Vendeur vérifié",
    lc_verified_breeder: "Éleveur vérifié", lc_verified_business: "Entreprise vérifiée",
    br_verified: "Vérification",
    br_verified_all: "Tous les vendeurs",
    lc_active_now: "En ligne",
    lc_no_photo: "Aucune photo",
    cat_all: "Toutes les annonces",
    // Dashboard
    d_title: "Mon tableau de bord",
    d_post_ad: "Publier",
    d_tab_listings: "Mes annonces",
    d_tab_messages: "Messages",
    d_tab_favorites: "Favoris",
    d_tab_profile: "Profil",
    d_loading: "Chargement",
    d_no_listings: "Vous n'avez pas encore publié d'annonce.",
    d_post_first: "Publier votre première annonce",
    d_views: "vues",
    d_pending: "En attente de révision",
    d_not_approved: "Non approuvée",
    d_expired: "Expirée",
    d_days_left: "j restants",
    d_edit_pending: "Modification en attente",
    d_renew: "Renouveler",
    d_renewed: "Renouvelée pour 30 jours",
    d_listing_removed: "Annonce supprimée",
    d_delete_listing_q: "Supprimer cette annonce ?",
    d_delete_listing_desc: "Cette annonce sera supprimée définitivement.",
    d_cancel: "Annuler",
    d_delete: "Supprimer",
    d_no_favorites: "Aucune annonce enregistrée. Touchez le cœur sur une annonce pour l'enregistrer.",
    d_edit_profile: "Modifier votre profil",
    d_tap_camera: "Touchez l'appareil photo pour téléverser une photo de profil",
    d_badge_shown: "badge — affiché partout sur CritterPosts",
    d_full_name: "Nom complet",
    d_public_username: "Nom d'utilisateur public",
    d_username_help: "C'est le nom affiché publiquement sur vos annonces. 3 à 20 caractères : lettres, chiffres, traits de soulignement. Laissez vide pour afficher votre nom complet.",
    d_phone_label: "Téléphone (affiché sur les annonces seulement si vous l'activez)",
    d_bio: "Biographie",
    d_bio_ph: "Parlez un peu de vous aux acheteurs…",
    d_save_changes: "Enregistrer les modifications",
    d_profile_updated: "Profil mis à jour !",
    d_photo_updated: "Photo mise à jour !",
    d_2fa_title: "Connexion à deux facteurs",
    d_2fa_desc: "Lorsqu'elle est activée, nous enverrons par courriel un code à 6 chiffres à saisir à la connexion — une protection supplémentaire si votre mot de passe fuit.",
    d_secq_title: "Question de sécurité",
    d_secq_set: "Définie — vous pouvez réinitialiser votre mot de passe avec elle si vous perdez l'accès à votre courriel.",
    d_secq_unset: "Définissez-en une pour récupérer votre compte sans courriel.",
    d_secq_choose: "Choisissez une question",
    d_secq_update: "Mettre à jour",
    d_secq_save: "Enregistrer",
    d_blocked_title: "Utilisateurs bloqués",
    d_blocked_some: "Ces personnes ne peuvent pas vous écrire.",
    d_blocked_none: "Vous n'avez bloqué personne. Bloquez quelqu'un depuis une conversation pour arrêter ses messages.",
    d_weekly_title: "Courriel récapitulatif hebdomadaire",
    d_weekly_desc: "Recevez le lundi un résumé des vues de vos annonces et des nouveaux messages de la semaine passée.",
    d_verify_title: "Vérification du vendeur",
    d_verify_verified: "Vous êtes un vendeur vérifié — le badge s'affiche sur votre profil et vos annonces.",
    d_verify_pending: "Votre demande est en cours de révision. Nous vous écrirons une fois la décision prise.",
    d_verify_rejected: "Votre dernière demande n'a pas été approuvée.",
    d_verify_reason: "Raison :",
    d_verify_cta_intro: "Obtenez un badge vérifié qui renforce la confiance des acheteurs. Soumettez un document rapide pour révision.",
    d_verify_new_request: "Soumettre une nouvelle demande",
    d_verify_request: "Demander la vérification",
    d_no_messages: "Aucun message pour l'instant. Les demandes que vous envoyez et recevez apparaîtront ici.",
    d_select_conv: "Sélectionnez une conversation",
    d_type_message: "Écrivez un message…",
    d_unblock_to_send: "Débloquez pour envoyer des messages",
    d_seen: "Vu",
    d_mute: "Mettre en sourdine",
    d_unmute: "Réactiver",
    d_block: "Bloquer",
    d_unblock: "Débloquer",
    d_report: "Signaler",
    d_announcement: "Annonce",
    d_direct_message: "Message direct",
    d_with: "avec",
    d_message_deleted: "Ce message a été supprimé",
    d_edited: "(modifié)",
    d_blocked_banner: "Vous avez bloqué cet utilisateur. Débloquez-le pour échanger des messages.",
    d_verify_dlg_title: "Demander la vérification",
    d_verify_dlg_desc_biz: "Vérifiez votre entreprise ou votre activité pour obtenir un badge de confiance.",
    d_verify_dlg_desc_ind: "Vérifiez votre identité pour obtenir un badge de confiance.",
    d_verify_biz_name: "Nom de l'entreprise / de l'activité",
    d_verify_website: "Site web (facultatif)",
    d_verify_full_name_label: "Nom légal complet",
    d_verify_full_name_ph: "Tel qu'il apparaît sur votre pièce d'identité",
    d_verify_verified_cat: "Vous êtes {badge} — le badge s'affiche sur votre profil et vos annonces.", d_verify_dlg_desc_breeder: "Montrez que vous êtes un éleveur responsable pour obtenir le badge violet Éleveur vérifié.", d_verify_doc_breeder: "Enregistrement de club / chenil ou référence vétérinaire",
    d_verify_doc_biz: "Licence / enregistrement d'entreprise",
    d_verify_doc_id: "Pièce d'identité gouvernementale",
    d_verify_upload: "Téléverser une image ou un PDF",
    d_verify_doc_uploaded: "Document téléversé",
    d_verify_doc_note: "Votre document sert uniquement à la révision et n'est jamais affiché publiquement.",
    d_verify_submit: "Soumettre pour révision",
    d_rm_title: "Signaler le message",
    d_rm_desc: "Ce message et votre raison sont envoyés à nos modérateurs pour révision.",
    d_rm_note_ph: "Ajoutez des détails (facultatif)…",
    d_rm_send: "Envoyer le signalement",
    d_dm_title: "Supprimer ce message ?",
    d_dm_desc: "Le message sera remplacé par « Ce message a été supprimé » pour tous dans la conversation. Cette action est irréversible.",
    d_cc_title: "Supprimer cette conversation ?",
    d_cc_desc: "Elle sera retirée de votre liste. L'autre personne garde sa copie, et elle peut réapparaître si l'un de vous envoie un nouveau message.",
    // Post ad / Create listing
    post_edit_title: "Modifier l'annonce",
    post_title: "Publier une annonce",
    post_sub: "Rejoignez des milliers d'amoureux des animaux partout au Canada — c'est gratuit.",
    post_canada: "Toutes les annonces doivent être au Canada 🇨🇦",
    post_photos: "Photos",
    post_add_photos: "Ajouter des photos",
    post_max_photos: "Nombre maximal de photos atteint. Retirez-en une pour en ajouter une autre.",
    post_details: "Détails",
    post_category: "Catégorie",
    post_title_label: "Titre",
    post_title_ph: "ex. Adorables chiots golden retriever",
    post_species: "Espèce",
    post_breed: "Race",
    post_age: "Âge",
    post_description: "Description",
    post_generate_ai: "Générer avec l'IA",
    post_desc_ph: "Décrivez l'animal, l'article ou le service…",
    post_price_location: "Prix et emplacement",
    post_price_type: "Type de prix",
    post_price_cad: "Prix (CAD)",
    post_province: "Province",
    post_city: "Ville",
    post_contact_prefs: "Préférences de contact",
    post_contact_sub: "Les acheteurs peuvent toujours vous écrire dans l'application. Choisissez ce que vous affichez d'autre publiquement.",
    post_show_email: "Afficher mon courriel",
    post_show_phone: "Afficher mon téléphone",
    post_submit: "Publier mon annonce",
    post_fixed: "Prix fixe",
    post_free: "Gratuit / adoption",
    post_contact: "Prix sur demande",
    post_submitted: "Soumis ! Votre annonce sera publiée une fois approuvée par notre équipe.",
    post_updated: "Annonce mise à jour !",
    post_need_title_city: "Veuillez ajouter un titre et une ville",
  },
};

// French names for the default category tiles (used when there is no admin override label).
export const CATEGORY_LABELS_FR = {
  all: "Toutes les annonces",
  dogs: "Chiens et chiots",
  cats: "Chats et chatons",
  birds: "Oiseaux",
  reptiles: "Reptiles",
  aquatics: "Aquatique",
  "small-pets": "Petits animaux",
  "supplies-services": "Fournitures et services",
  livestock: "Bétail",
  rescue: "Sauvetage",
  "lost-found": "Perdus et trouvés",
  iso: "Recherché (ISO)",
};

// Localized category label: French name when available, else the English label.
export function catLabel(lang, id, enLabel) {
  if (lang === "fr") return CATEGORY_LABELS_FR[id] || enLabel || id;
  return enLabel || id;
}

Object.assign(TRANSLATIONS.en, EXTRA_EN);
Object.assign(TRANSLATIONS.fr, EXTRA_FR);
